import { render, staticRenderFns } from "./f2g-icon.vue?vue&type=template&id=d9dc4436&scoped=true"
import script from "./f2g-icon.vue?vue&type=script&lang=js"
export * from "./f2g-icon.vue?vue&type=script&lang=js"
import style0 from "./f2g-icon.vue?vue&type=style&index=0&id=d9dc4436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9dc4436",
  null
  
)

export default component.exports